import { FeathersModel } from './feathersModel'
import { ContractTypeFull } from './contractType'

export type AssistantContractDay = {
  realizedDate: Date
  activityTimeSum: number
  transitTimeSum: number
  totalSum: number
}

export class AssistantContractWithTimeSummary extends FeathersModel {
  static serviceName = 'assistant-contract-with-time-summary'

  id: number
  validFrom: Date
  validTo: Date
  contractType?: ContractTypeFull
  jobNameOkSystemCode: number
  days: AssistantContractDay[]
}

export class AssistantContractDayTotal {
  activityTimeSumTotal: number = 0
  transitTimeSumTotal: number = 0
  totalSumTotal: number = 0
}

export class AssistantContractWithTimeSummaryWithTotals extends AssistantContractWithTimeSummary {
  totals: AssistantContractDayTotal
}

export type ColumnHeader = {
  header: string
  popperText?: string
  summable?: boolean
}

export type TopSectionText = {
  label: string
  content: string
}

export type TopSectionTextKeyValue =
  | 'tenantName'
  | 'organizationCity'
  | 'assistantFullname'
  | 'jobPosition'
  | 'workingTime'
  | 'monthYear'

export type UpdateTopSectionTextContent = {
  key: TopSectionTextKeyValue
  content: string
}
